<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0">
      <v-row>
        <v-col md="12">
          <v-card flat class="text-right v-card-bg-none">
            <v-card-actions style="display: flex; flex-wrap: wrap; gap: 1em">
              <v-btn color="secondary" outlined to="/my-team">
                <v-icon class="mr-1" small>fa-chevron-left</v-icon> Back to
                My Team
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                class="ml-0 add-course-button"
                color="primary"
                @click.prevent="showCreatePanel"
                outlined
              >
                Add External Training
              </v-btn>
              <v-btn
                class="ml-0 add-course-button"
                color="primary"
                @click.prevent="exportCsv('excel')"
                outlined
                v-if="serverItemsLength > 0"
              >
                Export Excel
              </v-btn>
              <v-btn
                class="ml-0 add-course-button"
                color="primary"
                @click.prevent="exportCsv('pdf')"
                outlined
                v-if="serverItemsLength > 0"
              >
                Export PDF
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-text-field
                class="search-box"
                placeholder="Search External Training"
                prepend-icon="fa-search"
                v-model="search"
                type="text"
                clearable
                clear-icon="fa-times"
                @click:clear="resetSearch('search')"
                @change="applySearch"
              ></v-text-field>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-select :items="categories" :clearable="true" item-text="name" item-value="id" ref="categoryFilterBox"
                placeholder="Search Training Category" multiple small-chips class="search-box" v-model="selectedCategory"
                v-on:change="filterTrainingType($event)" menu-props="content-class: dropdown-below" @click:clear="handleClear">
                <template v-slot:selection="{ item, index }">
                <template v-if="index < 2">
                  <v-chip :title="item.name" small>{{ $gf.truncateText(item.name, 6) }}</v-chip>
                </template>
                <template v-if="index === 2">
                  <v-chip small>...</v-chip>
                </template>
              </template>
                <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleSelectAll">
              <v-list-item-action>
                <v-checkbox :input-value="selectAll" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
          </v-select>  
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-text-field
                class="search-box"
                placeholder="Search Users By Name Or Email"
                prepend-icon="fa-search"
                v-model="searchUser"
                type="text"
                clearable
                clear-icon="fa-times"
                @click:clear="resetSearch('user')"
                @change="applySearch"
              ></v-text-field>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card flat class="v-card-bg-none">
            <v-card-actions class="mt-1">
              <v-menu
                :close-on-content-click="false"
                v-model="menuCompleted"
                offset-y
                :nudge-right="0"
                max-width="290"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    clearable
                    :value="computedCompletedDate"
                    placeholder="Search by Date Completed"
                    prepend-icon="fa fa-search"
                    class="search-box calender-box"
                    readonly
                    v-on="on"
                    filled
                    @click:clear="resetSearch('date')"
                    hide-details="auto"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="searchDateCompleted"
                  @change="applyDateSearch"
                  color="calender"
                ></v-date-picker>
              </v-menu>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        
      </v-row>
      <!--<v-row>
                <v-col md="12" class="text-right">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="mr-2" @click.prevent="showCreatePanel">Add External Training</v-btn>
                </v-col>
            </v-row>-->
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="trainings"
              :footer-props="{
                'items-per-page-options': [5, 10, 15, 20],
              }"
              class="training-table"
            >
            <template v-slot:item.name="{ item }">
                <span :title="item.name"> {{ item.name.length > 30 ? item.name.slice(0, 30) + '...' : item.name }} </span>
              </template>
              <template v-slot:item.completed="{ item }">
                {{ item.completed_formatted }}
              </template>
              <template v-slot:item.type="{ item }">
                {{ item.type_in_text }}
              </template>
              <template v-slot:item.deadline="{ item }">
                {{ item.deadline_formatted }}
              </template>
              <template v-slot:item.body="{ item }">
                <span :title="item.body"> {{ item.body ? (item.body.length > 30 ? item.body.slice(0, 30) + '...' : item.body) : '' }} </span>
              </template>
              <template v-slot:item.id="{ item }">
                <v-select
                  v-if="screenSize === 'tablet' || screenSize === 'mobile'"
                  v-model="selectedAction"
                  :items="getActionList(item)"
                  item-text="name"
                  item-value="id"
                  placeholder="Select Action"
                  @change="performAction(item)"
                ></v-select>
                <template v-else>
                <v-tooltip v-if="item.file" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :href="item.file.data.url"
                      v-on="on"
                      color="secondary"
                      target="_blank"
                      text
                      small
                    >
                      <v-icon small>fa-file-alt</v-icon>
                    </v-btn>
                  </template>
                  <span>View Certificate</span>
                </v-tooltip>
                <v-tooltip v-if="item.file" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="error"
                      text
                      small
                      @click.prevent="deleteCertificate(item.id)"
                    >
                      <v-icon small>fa-times</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete Certificate</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="secondary"
                      text
                      small
                      @click.prevent="showEditPanel(item.id)"
                    >
                      <v-icon small>fa-pencil-alt</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit training record</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="$improve-grey-900"
                      text
                      small
                      @click.prevent="deleteTraining(item.id)"
                    >
                      <v-icon small>fa fa-trash</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete training record</span>
                </v-tooltip>
                </template>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import externalAPI from '@/api/external.js';
import LayoutBasic from '@/layouts/Dashboard';
import AddExternalTrainingDrawer from '@/components/teammanager/external/AddExternalTrainingDrawer';
import EditExternalTraining from '@/components/teammanager/external/EditExternalTraining';
import moment from 'moment';
import { screensize } from '../../utils/screensize';

// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();
export default {
  name: 'TeamExternalTraining',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        { text: 'Course Title', value: 'name' },
        { text: 'Date Completed', value: 'completed' },
        { text: 'Training Category', value: 'type' },
        { text: 'Institute / Body', value: 'body', sortable: false },
        { text: 'Score (%)', value: 'score' },
        { text: 'Result', value: 'result' },
        { text: 'Cost (£)', value: 'cost' },
        { text: 'Expiry Date', value: 'deadline' },
        { text: 'User', value: 'user.data.email' },
        { text: '', value: 'id', align: 'end' },
      ],
      trainings: [],
      pagination: {},
      loading: false,
      options: {},
      search: '',
      searchUser: '',
      searchParams: '',
      confirmDelete: 'Are you sure you wish to delete this external training?',
      confirmCertificateDelete:
        'Are you sure you wish to delete this certificate?',
      menuCompleted: false,
      categories: [],
      searchTraining: [],
      searchDateCompleted: '',
      selectedAction: null,
      screenSize: currentScreenSize,
      selectedCategory: [],
    };
  },
  mounted() {
    this.setEventBus();
     this.handleResize();
     // Add event listener for screen size changes
    window.addEventListener('resize', this.handleResize);
    this.getTrainingCategories();
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    computedCompletedDate() {
      return this.searchDateCompleted
        ? moment(this.searchDateCompleted).format('DD/MM/YYYY')
        : '';
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    selectAll() {
      return this.selectedCategory.length === this.categories.length;
    },
  },
  watch: {
    options: {
      handler() {
        this.getExternalReports();
      },
      deep: true,
    },
  },
  beforeDestroy() {
    EventBus.$off('EXTERNAL_TRAINING_UPDATED', this.getExternalReports());

    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);
    this.screenSize = null;
  },
  methods: {
    setEventBus() {
      EventBus.$on('EXTERNAL_TRAINING_UPDATED', (payload) => {
        // this.options = payload;
        this.getExternalReports();
      });
      EventBus.$on('TRAINING_CATEGORY_UPDATED', () => {
        this.getExternalReports();
        this.getTrainingCategories();
      });
    },
     handleResize() {
      this.screenSize = getCurrentScreenSize();
    },
     getActionList(item) {
      let actions = [
        { name: 'View Certificate', action: () => this.openCertificate(item.file.data.url) },
        { name: 'Delete Certificate', action: () => this.deleteCertificate(item.id) },
        { name: 'Edit Training Record', action: () => this.showEditPanel(item.id) },
        { name: 'Delete Training Record', action: () => this.deleteTraining(item.id)},
      ];
      return actions;
    },
    performAction(item) {
      const selectedOption = this.getActionList(item).find(
        (option) => option.name === this.selectedAction
      );
      if (selectedOption) {
        selectedOption.action();
      }
      setTimeout(() => {
        this.selectedAction = null;
      }, 0);
    },
    openCertificate(url){
        if (url != null) {
        window.open(url, '_blank');
      }
    },
    resetSearch(type) {
      this.options.page = 1;
      switch (type) {
        case 'search':
          this.search = '';
          break;
        case 'date':
          this.searchDateCompleted = '';
          break;
        case 'user':
          this.searchUser = '';
          break;
        default:
          break;
      }
      this.applySearch();
    },
    applyDateSearch() {
      this.menuCompleted = false;
      this.applySearch();
    },
    filterTrainingType() {
      this.applySearch();
    },
    applySearch() {
      this.options.page = 1;
      this.searchParams = '';
      if (this.search) {
        this.searchParams = '&search=name:' + this.search;
      }
      if (this.searchUser) {
        this.searchParams += '&searchUser=' + this.searchUser;
      }
      if (this.searchDateCompleted) {
        this.searchParams += '&completed=' + this.searchDateCompleted;
      }
      if (this.selectedCategory.length) {
        this.searchParams += '&type=' + this.selectedCategory.toString();
      }
      this.getExternalReports();
    },
    getExternalReports() {
      this.loading = true;
      externalAPI
        .getAdminExternalTraining(this.params, this.searchParams)
        .then((resp) => {
          this.loading = false;
          this.trainings = resp.data.data;
          this.pagination = resp.data.meta.pagination;
        });
    },
    showCreatePanel() {
      this.$showPanel({
        component: AddExternalTrainingDrawer,
        openOn: 'right',
      });
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditExternalTraining,
        props: {
          id: id,
          options: this.options,
        },
        openOn: 'right',
      });
    },
    deleteTraining(id) {
      this.$snotify.confirm(this.confirmDelete, {
        backdrop:0.3,                         
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button', },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processDeleteTraining(toast, id),
          }          
        ],
      });
    },
    processDeleteTraining(toast, id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      externalAPI.removeExternalTraining(id).then(() => {
        this.getExternalReports();
        this.loading = false;
      });
    },
    deleteCertificate(id) {
      this.$snotify.confirm(this.confirmCertificateDelete, {
        backdrop:0.3,                         
        buttons: [
           { text: 'Cancel',className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processDeleteCertificate(toast, id)
          }         
        ],
      });
    },
    processDeleteCertificate(toast, id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      externalAPI.removeExternalTrainingCertificate(id).then(() => {
        this.getExternalReports();
        this.loading = false;
      });
    },
    exportCsv(type) {
      this.loading = true;
      this.searchParams = '';
      if (this.search) {
        this.searchParams = '&search=name:' + this.search;
      }
      if (this.searchUser) {
        this.searchParams += '&searchUser=' + this.searchUser;
      }
      if (this.searchDateCompleted) {
        this.searchParams += '&completed=' + this.searchDateCompleted;
      }
      if (this.selectedCategory.length) {
        this.searchParams += '&type=' + this.selectedCategory.toString();
      }
      externalAPI
        .exportExternalTrainingCSV(
          '?page=1&orderBy=&sortedBy=asc&limit=' + this.pagination.total,
          this.searchParams,
          '&export_type=' + type
        )
        .then((resp) => {
          window.open(resp.data);
          this.loading = false;
        });
    },
    getTrainingCategories() {
        externalAPI.getExternalTrainingCategories().then(response => {
            this.categories = response.data.data;
        });
    },
    handleClear(){
      const dropdown = this.$refs.categoryFilterBox.$el;
      dropdown.style.removeProperty("overflow");
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedCategory = [];
      } else {
        this.selectedCategory =  this.categories.map((cat) => cat.id);
      }

      this.applySearch();
    },
  },
};
</script>
<style>
.datepicker_search .v-input__prepend-outer {
  position: absolute;
  left: 10px;
}
.v-input.datepicker_search .v-input__control .v-input__slot {
  padding-left: 40px !important;
}
.calender-box.theme--light.v-text-field--filled > .v-input__control > .v-input__slot{
background : unset
}
.calender-box > .v-input__prepend-outer{
  margin-top: 4px;
}
.calender-box.theme--light.v-text-field--enclosed .v-input__append-inner{
  margin-top: 4px;
}
.calender-box.theme--light.v-text-field--filled:not(.v-text-field--single-line) input{
  margin-top: 0px;
}
.calender-box.theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot:hover{
  background : unset
}
.calender-box.theme--light.v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot{
display: block;
}
.calender-box.theme--light.v-text-field--filled > .v-input__control > .v-input__slot{
min-height: unset;
}
</style>
